import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../../api";
import { PageViewSetting } from "../../types/notebook/viewSetting";

// Typescript wrapper for https://github.com/The-Lambda-Group/query-omega-oql/blob/development/oql/app/public/api/page/view/setting.oql

/**
 * Get View Setting
 * @param viewId the view ID to get settings for
 */
export const getViewSetting: (config: {
  "view-id": string;
}) => Promise<PageViewSetting> = async (request) => {
  const ednString = toEDNStringFromSimpleObject(request as any, {
    keysAs: "string",
  });
  const query = `
    (datastore Qo.Public.Api.Page.View.Setting "omega/query-omega/public/api/page/view/setting")
    (Qo.Public.Api.Page.View.Setting/get-view-setting ${ednString} Response)
    (return [Response])
  `;
  return queryOmegaSingleResult(query);
};

/**
 * Set View Setting
 * @param setting the view setting object to save
 */
export const setViewSetting: (
  setting: PageViewSetting
) => Promise<PageViewSetting> = async (setting) => {
  const ednString = toEDNStringFromSimpleObject(setting as any, {
    keysAs: "string",
  });
  const query = `
    (datastore Qo.Public.Api.Page.View.Setting "omega/query-omega/public/api/page/view/setting")
    (Qo.Public.Api.Page.View.Setting/set-view-setting ${ednString} Response)
    (return [Response])
  `;
  return queryOmegaSingleResult(query);
};
